import { cn } from '@/lib/utils'
import { formatMinutes } from '@/lib/format'
import { resolveBillingTheme } from '../lib/theme'
import type { MinutesLedgerSummary } from '../types'

interface MinutesLedgerCardProps {
  ledger: MinutesLedgerSummary
  forecast: { daysRemaining: number; endDate: Date } | null
  isCurrent: boolean
}

export function MinutesLedgerCard({
  ledger,
  forecast,
  isCurrent,
}: MinutesLedgerCardProps) {
  // Match the heading color used by MinutesRemainingCard so the same
  // remainingMinutes value reads the same on both cards.
  const theme = resolveBillingTheme(
    isCurrent,
    forecast,
    ledger.remainingMinutes
  )
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="text-xs font-semibold tracking-widest text-muted-foreground uppercase mb-4">
        Minutes Ledger
      </div>
      <div className="space-y-3">
        <Row
          label="Start of period"
          value={formatMinutes(ledger.startMinutes)}
        />
        <Row label="Added" value={`+${formatMinutes(ledger.addedMinutes)}`} />
        <Row label="Used" value={`−${formatMinutes(ledger.usedMinutes)}`} />
        <div className="border-t border-border pt-3 flex justify-between">
          <span className="font-semibold">Remaining</span>
          <span className={cn('font-bold', theme.heading)}>
            {formatMinutes(ledger.remainingMinutes)}
          </span>
        </div>
      </div>
    </div>
  )
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between text-sm">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium">{value}</span>
    </div>
  )
}
